var fancyboxInit;

(function ($) {
	fancyboxInit = function () {

		$('.flexible-content a[href*="youtube.com/watch"]:not([data-fancybox])').attr('data-fancybox', '');
		$('.gallery a').attr('data-fancybox', 'post-gallery');
		$('.c-post-flexible .c-post-text-section a').filter(function () {
			return $(this).children('img').length > 0;
		}).attr('data-fancybox', 'post-gallery');

		if (typeof (Fancybox) !== 'undefined') {
			Fancybox.bind("[data-fancybox]:not(.is-cloned)", {
				backFocus: false,
				Thumbs: {
					type: "classic",
				},
			});
		}

	}

})(jQuery);

export default fancyboxInit;
